import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-036ec34f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "background custom-dark overflow-hidden",
  id: "touchInterfacePlaying"
}, null, -1))
const _hoisted_2 = { class: "p-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-5xl text-text-white font-bold m-4" }, "Kies een verhaal")
], -1))
const _hoisted_4 = { class: "touchinterface-height relative p-8 bg-background-medium rounded-2xl" }
const _hoisted_5 = { class: "flex flex-col items-center justify-center mb-4" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg viewBox=\"0 0 120 74\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"h-16\" data-v-227ed960=\"\" data-v-036ec34f><path d=\"M55.7893 38.0144C51.3109 36.9677 47.383 34.2903 44.7716 30.5045C42.1601 26.7187 41.0525 22.0959 41.6646 17.5377C42.2767 12.9796 44.5647 8.81279 48.0824 5.85007C51.6001 2.88735 56.0952 1.34111 60.6911 1.51291C65.287 1.68472 69.6541 3.56224 72.9408 6.77932C76.2274 9.9964 78.198 14.3224 78.4681 18.9135C78.7382 23.5047 77.2885 28.0319 74.4017 31.6121C71.5149 35.1924 67.398 37.569 62.854 38.2785\" stroke=\"#212121\" stroke-width=\"3\" data-v-227ed960=\"\" data-v-036ec34f></path><circle cx=\"12\" cy=\"20\" r=\"10.5\" stroke=\"#212121\" stroke-width=\"3\" data-v-227ed960=\"\" data-v-036ec34f></circle><circle cx=\"108\" cy=\"20\" r=\"10.5\" stroke=\"#212121\" stroke-width=\"3\" data-v-227ed960=\"\" data-v-036ec34f></circle><path d=\"M54.5 21.5L57.5 24.5L64.5 15.5\" stroke=\"#212121\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-227ed960=\"\" data-v-036ec34f></path><path d=\"M76.3329 70.5L79.2379 56.557C79.9289 53.242 77.7409 50.013 74.4069 49.425L63.4999 47.5V34C63.4999 32.067 61.9329 30.5 59.9999 30.5C58.0669 30.5 56.4999 32.067 56.4999 34V57.358C56.4999 59.182 54.2579 60.054 53.0259 58.709L47.7069 52.906C46.4219 51.506 44.3299 51.202 42.6999 52.18C41.4649 52.921 41.0219 54.497 41.6899 55.773L49.4069 70.506\" stroke=\"#212121\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-227ed960=\"\" data-v-036ec34f></path></svg>", 1)
const _hoisted_7 = { class: "mx-8 text-2xl font-bold text-center py-4" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-evenly items-center my-48"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "flex items-center justify-center my-48"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Terug naar het overzicht", -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("main", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.wallIsPlaying ? 'Verhaal is bezig: ' + _ctx.titleSelectedStory : 'Kies een verhaal'), 1)
        ]),
        (!_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stories, (story, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: story.id,
                  onClick: ($event: any) => (_ctx.changeWallStory(story)),
                  class: _normalizeClass([
            'w-52 h-52 flex justify-center items-center text-3xl font-bold text-text-white rounded-full cursor-pointer text-center',
            `${_ctx.stories.length === 2 ? _ctx.colors[index + 1] : _ctx.colors[index]}`,
            {
              'opacity-10 cursor-not-allowed': _ctx.wallIsPlaying === true,
            },
          ])
                }, [
                  _createElementVNode("p", null, _toDisplayString(story.title[0].value), 1)
                ], 10, _hoisted_9))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createVNode(_component_Spinner)
            ])),
        _createElementVNode("div", null, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resetWall())),
            class: "absolute bottom-8 text-xl rounded-md p-4 bg-opacity-80 cursor-pointer bg-background-light"
          }, _hoisted_12)
        ])
      ])
    ])
  ], 64))
}